import { nodeInputRule } from '@tiptap/core';
import TTHorizontalRule from '@tiptap/extension-horizontal-rule';

export const MarkdownHorizontalRule = TTHorizontalRule.extend({
  addInputRules() {
    return [
      nodeInputRule({
        find: (text) => {
          if (
            this.editor.isActive('orderedList') ||
            this.editor.isActive('bulletList') ||
            !this.editor.isActive('paragraph')
          ) {
            return null;
          }
          const match = text.match(/^___$/);
          if (!match) {
            return null;
          }
          return {
            index: 0,
            text,
            match,
          };
        },
        type: this.type,
      }),
    ];
  },
});
